import { useState, useEffect, useContext } from 'react';
import { HttpContext } from '../../api-services/HttpService';
import LightPersonIcon from '../../svgs/light-person-icon.svg';
import DarkPersonIcon from '../../svgs/dark-person-icon.svg';
import WarningIcon from '../../svgs/warning-icon.svg';
import displayDateTime from '../functions/displayDateTime';
import  '../../css/offcanvasStyle.css';

const WorkflowCommentLog = ({workflowid,disableHeight=false}) => {
    // initialize http context 
    const {
        GET,
    } = useContext(HttpContext);
    // initialize state 
    const [commentList, setCommentList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    //function to call api to get commennt log. takes in a workflowid
    const getComments = (workflowid) => {
        return new Promise((resolve, reject) => {
            GET('/rebate/summary/comment/log', { workflowid: workflowid }).then(res => {
                //set comment log
                setCommentList(commentList => commentList = res.data.CommentLog);
                resolve(res);
            }).catch(err => {
                reject(err);
            }).finally(() => setIsLoading(false));
        });
    }
    // useEffect to run on initial render
    useEffect(() => {
        getComments(workflowid).then(res => {
            console.log(res);
        }).catch(err => {
            console.log(err);
        });
    }, [workflowid]);


    const formatDate = (date) => {
        const now = new Date();
        const diffMs = now - new Date(date);
        const diffSeconds = diffMs / 1000;
        // If less than or equal to 24 hours ago
        if (diffSeconds <= 86400 ) {
            if (diffSeconds < 60) {
                // Less than a minute
                const secs = Math.floor(diffSeconds);
                return `${secs} second${secs !== 1 ? 's' : ''}`;
            } else if (diffSeconds < 3600) {
                // Less than an hour
                const mins = Math.floor(diffSeconds / 60);
                return `${mins} minute${mins !== 1 ? 's' : ''}`;
            } else {
                // Less than 24 hours
                const hours = Math.floor(diffSeconds / 3600);
                return `${hours} hour${hours !== 1 ? 's' : ''}`;
            }
        } else {
            return displayDateTime(date);
        }
    }

    return (
        <div>
            <div className="offcanvas-details p-3" style={{fontSize: '12px', borderBottom: "1px solid #ECECEC"}}>Comment Log ({`${commentList.length}`}) </div>
            <div style={{ overflowY: 'auto', height: (disableHeight? '':'calc(100vh - 320px)') }}>
                {commentList.length > 0 ? commentList.map((el, idx) =>
                    <div style={{ backgroundColor: idx % 2 === 0 ? '#F7F9FA' : '#FFFFFE', border: '0.05rem solid #E6EDF1', height: '64px', padding: '8px 0px', fontSize: '12px' }}>
                        <div className="d-flex align-items-center p-1" >
                            <img src={idx % 2 === 0 ? LightPersonIcon : DarkPersonIcon} className='ms-2 align-self-baseline' />
                            <div className='ps-2'>
                                {el['lastupdateduser']} <span className='ms-3' style={{color: '#BDBDBD'}}>{formatDate(el['lastupdatedtimestamp'])}</span>
                                <div class="text-break" style={{color: '#3D3D3D'}}>{el['commenttext']}</div>
                            </div>
                        </div>
                    </div>

                ) : (isLoading ? null : <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                    <div className={disableHeight?'p-3':''}>
                        <div className="d-flex justify-content-center">
                            <img src={WarningIcon}></img>
                        </div>
                        <div>No Comments found here</div>
                    </div>
                </div>)}

            </div>
        </div>
    );
}

export default WorkflowCommentLog; 
